import React, { Component, Fragment } from "react";
import "./style.scss";
import Table from "../../../components/table";
import Button from "../../../components/button";
import AdminUserAdd from "./admin-user-add";
import AdminUserDelete from "./admin-user-delete";
import { connect } from "react-redux";
import queryString from 'query-string';
import {toast} from 'react-toastify';

import { getAdminUsers, convertAdminUsers, ACTIONS, deleteAdminUsers } from './../../../actions/admin-user';
import Loading from "../../../components/loading";


class AdminUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading : true,
            showModalAdd: false,
            showModalSetting: false,
            showModalDelete: false,
            listUser: [],
            listUserSearch : [],
            meta: null,
            detailUser : null,
            id : null,
            showPopup : false,
            message : '',
            isAdd : false,
            keyword: '',
            isReciveProps: false
        }
    }

    addData = () => {
        this.setState({
            showModalAdd : true,
            showPopup : false,
            isAdd : true,
            detailUser : null
        })
    }

    handleActionTable = (key, val, item) => {
        if (val === 0) {
            this.setState({
                detailUser : item,
                showModalAdd : true,
                showPopup : false,
                isAdd : false
            });
        } else {
            this.setState({
                id : item[0].id,
                email: item[1].text,
                showModalDelete  :true,
                showPopup : false
            })
        }
    }

    closeAddUser = () => {
        this.setState({
            showModalAdd: false,
            showModalSetting: false,
            showModalDelete: false,
        })
    }

    onAddUser = () => {
        this.closeAddUser();
        this.getData();
    }

    componentDidMount = () => {
        this.getData();

    }

    getData = () => {
        const values = queryString.parse(this.props.location.search);
        this.props.getAdminUsers(values.page || 1, values.keyword || "");
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps && nextProps.response) {
            if (nextProps.type === ACTIONS.GET_DATA_ADMIN_USER_SUCCESS) {
                this.setState({
                    showLoading: false,
                    listUser: convertAdminUsers(nextProps.response),
                    listUserSearch: convertAdminUsers(nextProps.response),
                    meta: nextProps.meta,
                });
            }

            if (nextProps.type === ACTIONS.UPDATE_ADMIN_USERS_ERROR
                || nextProps.type === ACTIONS.DELETE_ADMIN_USERS_ERROR
                || nextProps.type === ACTIONS.ADD_ADMIN_USERS_ERROR ) {

                this.setState({
                    message : nextProps.message,
                    isReciveProps: true
                });
                toast.success(nextProps.message);
            }

            if (nextProps.type === ACTIONS.UPDATE_ADMIN_USERS_SUCCESS) {

                this.setState({
                    message : nextProps.message,
                    isReciveProps: true
                });
                toast.success('スタッフを編集しました');
            }

            if (nextProps.type === ACTIONS.ADD_ADMIN_USERS_SUCCESS) {

                this.setState({
                    message : nextProps.message,
                    isReciveProps: true
                });
                toast.success('スタッフを追加しました');
            }

            if (nextProps.type === ACTIONS.DELETE_ADMIN_USERS_SUCCESS) {
                this.getData();
                this.setState({
                    isReciveProps: true
                });
                toast.success('スタッフを削除しました');
            }

        }
    }


    searchAdminUser = (e) => {
        // const arrNew = this.state.listUserSearch.filter((val, i) => {
        //     return val.item[0].text.includes(e.target.value) || val.item[1].text.includes(e.target.value);
        // })
        if (e.key === 'Enter') {
            this.setState(
                {keyword: e.target.value
                }, () => {
                    this.props.getAdminUsers(1, this.state.keyword);
            })
        }
    }

    closeModalMessage = () => {
        this.setState({
            showPopup : false
        })
    }

    returnActionDelete = (id) => {
        this.setState({ showLoading : true });
        this.props.deleteAdminUsers(id);
    }

    onChangePage(page, check) {
        this.setState({
            showLoading  :true
        })
        this.props.getAdminUsers(page,  "");

    }


    render() {
        return (
            <Fragment>
                <div className="admin-user">
                    <div className="block-title">
                        <h2 className="block-title__text--main">スタッフ</h2>
                        <div className="search-custom">
                            <input type="text" className="searchbox" placeholder="検索" onKeyDown={(e) => this.searchAdminUser(e)} />
                            <Button showIcon={true} title="新規作成" addData={() => this.addData()} />
                        </div>
                    </div>

                    <div className="block-content">
                        <div className="wrapper">
                            <Table header={this.props.header}
                                showPaginationTop={true}
                                showCheckbox={false}
                                meta={this.state.meta}
                                actionItemDropdownDot={this.handleActionTable}
                                showSearch={false}
                                itemOfPage={this.state.listUser}
                                onChangePage={(page, check) => this.onChangePage(page, check)}
                            />
                        </div>
                    </div>
                </div>
                {
                    this.state.showModalAdd && <AdminUserAdd
                        detailUser={this.state.detailUser}
                        isAdd={ this.state.isAdd }
                        textEdit={!this.state.isAdd && '変更'}
                        onClose={() => this.closeAddUser()}
                        onCreate={() => this.onAddUser()} />
                }
                {
                    this.state.showModalDelete
                        ? <AdminUserDelete
                            returnActionDelete={(id) => this.returnActionDelete(id)}
                            id={this.state.id}
                            email={this.state.email}
                            onClose={() => this.closeAddUser()}
                            />
                        : null
                }
                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ adminUsers }) => {
    return {
        header: adminUsers.header,
        dataAdminNews: adminUsers.dataAdminUsers,
        response: adminUsers.response,
        pageSize: adminUsers.pageSize,
        status: adminUsers.status,
        type: adminUsers.type,
        meta: adminUsers.meta,
        message : adminUsers.message,
        time : adminUsers.time

    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAdminUsers: (page, keyword) => {
            dispatch(getAdminUsers(page, keyword));
        },
        deleteAdminUsers: (id) => {
            dispatch(deleteAdminUsers(id));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(AdminUser);
